import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class ViewApplicationLocationAConstants {
    static DESCRIPTION_LABEL_1 = "Search the map to find the advertisement for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct advertisement and click on the advertisement. Click on 'add advertisement' in the window that appears on the map after you selected the advertisement.";
    static DESCRIPTION_LABEL_3 = "The advertisement will be added and the fields must be completed for the advertisement.";
    static IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_LABEL = "Is the advertising permanent or temporary?";
    static APPLICATION_TYPE_LABEL = "Application type";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static ADVERTISEMENT_FORM_GROUP_NAME = "advertisementsForm";
    static ADVERTISEMENT_FORM_CONTROL_NAME = "advertisements";
    static AREA_OF_DISPLAY_FORM_CONTROL_NAME = "areaOfDisplay";
    static IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_FORM_CONTROL_NAME = "isAdvetisingPermanentOrTemporary";
    static STREET_NAMES_FORM_CONTROL = "streetNames";
    static PROPERTY_DESCRIPTION_FORM_CONTROL_NAME = "propertyDescription";
    static ADDRESS_OR_STREET_FORM_CONTROL_NAME = "addressStreetInformation";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static AREA_OF_CONTROL_LABEL = "Area of control";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static STREET_NAMES_LABEL = "Street names";
    static PROPERTY_DESCRIPTION_LABEL = "Property description (If it is a private sale or permanent advertisement)";
    static ADDRESS_OR_STREET_LABEL = "Address / Street information";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static VALIDATION_MESSAGES = {
        areaOfDisplay: {
            required: `Area of display ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, streetNames: {
            required: `Street names ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, propertyDescription: {
            required: `Property description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, addressOrStreet: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, isAdvertisingPermanentOrTemporary: {
            required: `is advertising permanent or temporary ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, applicationType: {
            required: `is advertising permanent or temporary ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
    static POLYGON_SKETCH_TOOLS_OPTIONS = {
        createTools: {
            point: false, circle: false, polyline: false, rectangle: false
        }, selectionTools: {
            "lasso-selection": false, "rectangle-selection": false
        }
    };
    static POINT_SKETCH_TOOLS_OPTIONS = {
        createTools: {
            circle: false, polygon: false, polyline: false, rectangle: false
        }, selectionTools: {
            "lasso-selection": false, "rectangle-selection": false
        }
    };
    static MODAL_OPTIONS = {
        size: "xl",
        centered: true,
        keyboard: false,
        backdrop: "static"
    };
}
